import { BaseDataItem, Component, WidgetRefDataItem } from '@wix/thunderbolt-becky-types'
import { createCompNode, NodeRefs } from '@wix/thunderbolt-catharsis'

const isBuilderCompData = (comp: Component, compData: BaseDataItem): compData is WidgetRefDataItem =>
	(compData as WidgetRefDataItem)?.isBuilderComponent !== undefined

export const widgetIdsNode = createCompNode({
	getDependencies: (component: Component, refs: NodeRefs<{}>) => ({
		compPresets: refs.presetsQuery(component.presetsQuery!),
		compData: refs.dataQuery(component.dataQuery!),
	}),
	toViewItem: (comp, { compData }) => {
		if (!isBuilderCompData(comp, compData) || !compData.isBuilderComponent) {
			return
		}
		const { widgetId, appDefinitionId } = compData

		return [
			{
				widgetId,
				appDefinitionId,
			},
		]
	},
})
